import { combineReducers } from 'redux'
import pedidos from './pedidos'
import login from './login'

export default combineReducers({
    pedidos,
    login
})
